import React from 'react';

const ChildAccordion = ({
  childName = "Child Name",
  age = "30",
  ageUnit = "months",
  questionnaire = "30 - 35 months",
  translationMap = {}
}) => {
  return (
    <div className="Inner_Box">
            <div className="custom_accordion_box custom_accordion_box3">
                <button
          className="btn accordion-button"
          type="button"
          data-toggle="collapse"
          data-target="#collapseExample"
          aria-expanded="false"
          aria-controls="collapseExample">
          
                    <span>
                        {childName}
                    </span>

                </button>

                <div className="collapse show" id="collapseExample">
                    <div className="card card-body">
                        <div className="accordion_content_box">
                            <ul className="ul_box">
                                <li>
                                    <p>
                                        {translationMap?.age ?? "Age"}{":"} <b>{age} {translationMap?.months ?? ageUnit}</b>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {translationMap?.theQuestionnaireText ?? "Questionnaire:"} <b>{questionnaire}</b>
                                    </p>
                                </li>
                            </ul>
                            <h6 className="MainTitleOne">
                                {translationMap?.prematureNote ??
                "Note: If your child was born premature, corrected age is calculated according to the duration of pregnancy."
                }
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>);

};

export default ChildAccordion;